/**
 * What a report can be about (P2-SAFE-01, docs/safety-and-privacy.md). Ids go on the wire and into
 * D1; the client shows its own wording. Placeholder set for the beta, easy to extend: adding one
 * is additive, removing one isn't.
 */
export const REPORT_CATEGORIES = ["harassment", "cheating", "name", "spam", "other"] as const;
export type ReportCategory = (typeof REPORT_CATEGORIES)[number];

/** The reporter's optional note (D1 checks the same limit). */
export const MAX_REPORT_NOTE_CHARS = 500;

export const isReportCategory = (value: string): value is ReportCategory =>
  (REPORT_CATEGORIES as readonly string[]).includes(value);
